import React,{useState, useEffect, Fragment,useRef} from "react"
import Userimg from '../assets/robin-aylor-pic.jpg'
import Userimg2 from '../assets/userimg.png'
import '../css/devoloper2.css'
import {  useNavigate, useParams } from 'react-router-dom'
import axios from "axios";
import { userurl} from '../apis/urls'
import { useSetState } from "@mantine/hooks";
import SideNavbar from "./sideNavbar"
import { $ } from "react-jquery-plugin"
import { allschools } from "../apis/urls";
import jsPDF from 'jspdf';
import { decode } from "html-entities";

const HeadNavbar = () =>{

    const { id } = useParams();
    
    let navigate = useNavigate();
    const Logout = () => {
        let urole = localStorage.getItem('userrole');

        if(urole === 'SUPERADMIN'){
            localStorage.removeItem('token');
            localStorage.removeItem('username');
            localStorage.removeItem('userid');
            localStorage.removeItem('userrole');
            localStorage.removeItem('test_attempted')
            localStorage.removeItem('association')
            localStorage.removeItem('coachId')
           
            navigate("/admin")

        }else if(urole === 'ASSOCIATION_USER'){
                localStorage.removeItem('token');
                localStorage.removeItem('username');
                localStorage.removeItem('userid');
                localStorage.removeItem('userrole');
                localStorage.removeItem('test_attempted')
                localStorage.removeItem('association')
               
                navigate("/associations/login")
    
        }else{
        let store = localStorage.getItem('token');
        // console.log('key',store)
        localStorage.removeItem('token');
        localStorage.removeItem('username');
        localStorage.removeItem('userid');
        localStorage.removeItem('userrole');
        localStorage.removeItem('test_attempted')
        localStorage.removeItem('association')

        
        navigate("/")
        }
        //window.location.href = "gisa/";
      }

    //   useEffect(() => {
    //     Username();
    // },[]
    // );


        let uid = localStorage.getItem('userid');
        let username = localStorage.getItem('username');
        let urole = localStorage.getItem('userrole');
        let tokens = localStorage.getItem('token');


        // console.log('id', uid)

        const [toggle, setToggle] = useState(true)


        const toggleOpenButton = () => 
        {
            $('body').removeClass('').addClass('sidebar-collapsed sidebar-active');
            setToggle(false)
        };

        const toggleCloseButton = () => 
        {
            $('body').removeClass('sidebar-active').addClass('');
            setToggle(true)

        };

       let resetPassword = () => {
           navigate('/reset_password')
       }

       const coach =  localStorage.getItem('coachname');

      
  const [resultall, setResultall] = useState([]);

  useEffect(() => {
    const fetchSchoolData = async () => {
      try {
        const response = await axios.get(allschools);
        console.log("Response data is", response.data);
        setResultall(response.data.data);
      } catch (error) {
        console.error('Error fetching school data:', error.message);
      }
    };

    fetchSchoolData();
  }, []);

  const generatePDF2 = () => {
    const doc = new jsPDF('p', 'mm', 'a4');
    const pageWidth = doc.internal.pageSize.getWidth();
    const pageHeight = doc.internal.pageSize.getHeight();
    
    // Set margins and column width
    const margins = { top: 20, bottom: 20, left: 10, right: 10 };
    const columnWidth = (pageWidth - margins.left - margins.right) / 2;
    let y = margins.top;
    let page = 1;

    const addPageBorderAndNumber = () => {
        doc.setDrawColor(0);
        doc.setLineWidth(0.5);
        doc.rect(margins.left - 5, margins.top - 5, pageWidth - margins.left - margins.right + 10, pageHeight - margins.top - margins.bottom + 15);
        doc.setFontSize(10);
        const pageNumberYPosition = pageHeight - margins.bottom + 18;
        doc.text(`Page ${page}`, pageWidth / 2, pageNumberYPosition, { align: 'center' });
    };

    // Calculate minimum height needed for a school entry
    const calculateMinSchoolHeight = (school) => {
        let minHeight = 20; // Base height for school name and spacing
        if (school.address_1 || school.address_2) minHeight += 4;
        if (school.city) minHeight += 4;
        if (school.phone) minHeight += 4;
        if (school.website) minHeight += 4;
        
        // Add minimum height for faculty sections
        const faculty = formatFacultyGroups(school.school_faculties);
        if (faculty.headOfSchool.length) minHeight += 8;
        if (faculty.athleticManager.length) minHeight += 8;
        if (faculty.otherFaculty.length) minHeight += 12;
        
        return minHeight;
    };

    const checkNewPageForSchool = (currentY, school1, school2 = null) => {
        const height1 = calculateMinSchoolHeight(school1);
        const height2 = school2 ? calculateMinSchoolHeight(school2) : 0;
        const maxHeight = Math.max(height1, height2);
        
        // If there isn't enough space for the taller school entry, start a new page
        if (currentY + maxHeight > pageHeight - margins.bottom - 10) {
            doc.addPage();
            page++;
            addPageBorderAndNumber();
            return margins.top;
        }
        return currentY;
    };

    const checkNewPage = (currentY, lineHeight = 4) => {
        if (currentY + lineHeight > pageHeight - margins.bottom - 10) {
            doc.addPage();
            page++;
            addPageBorderAndNumber();
            return margins.top;
        }
        return currentY;
    };

    // Add title
    doc.setFontSize(16);
    doc.setFont(undefined, 'bold');
    doc.setTextColor(255, 0, 0);
    doc.text('GISA MEMBER SCHOOLS DIRECTORY', pageWidth / 2, y, { align: 'center' });
    y += 7;

    addPageBorderAndNumber();

    const formatFacultyGroups = (faculty) => {
        const groups = {
            headOfSchool: [],
            athleticManager: [],
            otherFaculty: []
        };

        faculty?.forEach(member => {
            let isHeadOfSchool = false;
            let isAthleticManager = false;
            let hasOtherPositions = false;

            // Check all positions
            member.faculty_multiple_positions.forEach(position => {
                if (position.faculty_position.name === "Head of School") {
                    isHeadOfSchool = true;
                } else if (position.faculty_position.name === "Athletic Director") {
                    isAthleticManager = true;
                } else {
                    hasOtherPositions = true;
                }
            });

            // Add to respective groups
            if (isHeadOfSchool) {
                groups.headOfSchool.push(member);
            }
            if (isAthleticManager) {
                groups.athleticManager.push(member);
            }
            // Add to otherFaculty if they have any position other than Head/Athletic
            if (hasOtherPositions) {
                groups.otherFaculty.push(member);
            }
        });

        return groups;
    };

    const addAlignedLine = (text1, text2, currentY, isHeader = false) => {
        currentY = checkNewPage(currentY);
        
        const col1X = margins.left;
        const col2X = margins.left + columnWidth + 5;
        
        if (isHeader) {
            doc.setFillColor(0, 0, 0);
            doc.rect(col1X, currentY - 4, columnWidth - 3, 6, 'F');
            if (text2) {
                doc.rect(col2X, currentY - 4, columnWidth - 3, 6, 'F');
            }
            doc.setTextColor(255, 255, 255);
        } else {
            doc.setTextColor(0);
        }

        if (text1?.trim()) doc.text(text1, col1X, currentY);
        if (text2?.trim()) doc.text(text2, col2X, currentY);

        return currentY + 4;
    };

    // Process schools in pairs
    for (let i = 0; i < resultall.length; i += 2) {
        const school1 = resultall[i];
        const school2 = i + 1 < resultall.length ? resultall[i + 1] : null;

        // Check if we need a new page before adding the school pair
        y = checkNewPageForSchool(y, school1, school2);

        // Add school names (headers)
        doc.setFontSize(12);
        doc.setFont(undefined, 'bold');
        y = addAlignedLine(
            `${i + 1}. ${decode(school1.name)}`,
            school2 ? `${i + 2}. ${decode(school2.name)}` : '',
            y,
            true
        );
        y += 2;

        // Reset font settings for regular content
        doc.setFontSize(10);
        doc.setFont(undefined, 'normal');

        if (school1.address_1 || (school2 && school2.address_1)) {
            y = addAlignedLine(
                `${school1.address_1 || ''} ${decode(school1.address_2) || ''}`,
                school2 ? `${school2.address_1 || ''} ${decode(school2.address_2) || ''}` : '',
                y
            );
        }

        if (school1.city || (school2 && school2.city)) {
            y = addAlignedLine(
                school1.city ? `${decode(school1.city)}, ${decode(school1.state)} ${school1.zip}` : '',
                school2?.city ? `${decode(school2.city)}, ${decode(school2.state)} ${school2.zip}` : '',
                y
            );
        }

        if (school1.phone || (school2 && school2.phone)) {
            y = addAlignedLine(
                school1.phone ? `Tel: ${school1.phone}` : '',
                school2?.phone ? `Tel: ${school2.phone}` : '',
                y
            );
        }

        if (school1.website || (school2 && school2.website)) {
            y = addAlignedLine(
                school1.website ? `Website: ${school1.website}` : '',
                school2?.website ? `Website: ${school2.website}` : '',
                y
            );
        }

        y += 2;

        // Process faculty sections
        const faculty1 = formatFacultyGroups(school1.school_faculties);
        const faculty2 = school2 ? formatFacultyGroups(school2.school_faculties) : null;

        const addFacultySection = (title, list1, list2) => {
            if (!list1?.length && !list2?.length) return;

            // Add section header
            doc.setFont(undefined, 'bold');
            y = addAlignedLine(
                list1?.length ? title : '',
                list2?.length ? title : '',
                y
            );
            doc.setFont(undefined, 'normal');

            const maxLength = Math.max(list1?.length || 0, list2?.length || 0);

            for (let j = 0; j < maxLength; j++) {
                const member1 = list1?.[j];
                const member2 = list2?.[j];

                if (member1 || member2) {
                    const member1Name = [
                        decode(member1?.title || ''), 
                        decode(member1?.first_name || ''), 
                        decode(member1?.last_name || '')
                    ].filter(Boolean).join(' ');

                    const member2Name = [
                        decode(member2?.title || ''), 
                        decode(member2?.first_name || ''), 
                        decode(member2?.last_name || '')
                    ].filter(Boolean).join(' ');

                    if (title === 'Other Staff') {
                        doc.setFont(undefined, 'bold');
                    }

                    // Add names first
                    y = addAlignedLine(
                        member1 ? member1Name : '',
                        member2 ? member2Name : '',
                        y
                    );
                    doc.setFont(undefined, 'normal');

                    // For non-'Other Faculty', add email immediately after name
                    if (title !== 'Other Staff') {
                        if (member1?.email || member2?.email) {
                            y = addAlignedLine(
                                member1?.email || '',
                                member2?.email || '',
                                y
                            );
                        }
                    }

                    // Add positions and email for 'Other Faculty'
                    if (title === 'Other Staff') {
                        const positions1 = member1?.faculty_multiple_positions || [];
                        const positions2 = member2?.faculty_multiple_positions || [];
                        const maxPositions = Math.max(positions1.length, positions2.length);

                        for (let k = 0; k < maxPositions; k++) {
                            doc.setFont(undefined, 'italic');
                            y = addAlignedLine(
                                positions1[k] ? `• ${positions1[k].faculty_position.name}` : '',
                                positions2[k] ? `• ${positions2[k].faculty_position.name}` : '',
                                y
                            );
                            doc.setFont(undefined, 'normal');
                        }

                        // Add email after positions for 'Other Faculty'
                        if (member1?.email || member2?.email) {
                            y = addAlignedLine(
                                member1?.email || '',
                                member2?.email || '',
                                y
                            );
                        }

                        y += 5;
                    }
                }
            }
            y += 2;
        };

        // Only add sections that have data
        if (faculty1.headOfSchool.length || (faculty2 && faculty2.headOfSchool.length)) {
            addFacultySection('Head of School', faculty1.headOfSchool, faculty2?.headOfSchool);
        }

        if (faculty1.athleticManager.length || (faculty2 && faculty2.athleticManager.length)) {
            addFacultySection('Athletic Director', faculty1.athleticManager, faculty2?.athleticManager);
        }

        if (faculty1.otherFaculty.length || (faculty2 && faculty2.otherFaculty.length)) {
            addFacultySection('Other Staff', faculty1.otherFaculty, faculty2?.otherFaculty);
        }

        y += 8; // Space between school pairs
    }

    doc.save('schools_directory.pdf');
};

  const handleNavigate = () => {
    navigate("/listofschool")
    
  };
  

    return( 
        <Fragment>

            <Fragment>
                <SideNavbar />
            </Fragment>

<div>
    <div className="wrapper" >
        <aside>      		
			<header>
				<div className="title-and-userprofile-wrpr" >
					<div>
                        {toggle?<div>
						<button onClick={toggleOpenButton} className="sidebar-toggler icon-menu1 close"></button>	
                        </div>:
                        <div>
                        <button onClick={toggleCloseButton} className="sidebar-toggler icon-menu1 close"></button>
                        </div>	
                        }
					</div>
					<div className="user-profile-wrpr nav navbar-nav">
						<div className="navbar-collapse">
                            
                            {
                                tokens?
                                    (<div className="navbar">
                                        <div className="page-rightside-action-column mb-3">   
                                         
                                           
                                           
                                        <>
                                        {(urole === 'HO_SCHOOL' || urole === 'SUPERADMIN' || urole === 'ATHLETIC_MANAGER') && (
                                          <div className="flex items-center flex-wrap gap-4">
                                          <div class="searchdirectory" style={{ position: "relative", display: "inline-block" }}>
                                            <input
                                                type="text"
                                                className="form-controls search-bar asso-search"
                                                style={{
                                                padding: "10px 10px 10px 30px", // Add left padding for icon
                                                borderRadius: "20px",
                                                border: "1px solid #ccc",
                                                width: "100px",
                                                cursor:"pointer"
                                                }}
                                                onClick={handleNavigate}
                                                placeholder="Search Directory"
                                                readOnly
                                            />
                                            </div>

                                          

                                          
                                            
                                           
                                            <button
                                              onClick={generatePDF2}
                                              style={{
                                                padding: "10px",
                                                background: '#4077c7',
                                                borderRadius: "5px",
                                                color: '#fff',
                                                marginRight: '80px',
                                                marginTop: '20px'
                                              }}
                                              className="addbtnitem-link text-anchor"
                                            >
                                              Download Directory
                                              <i
                                                className="icon-download"
                                                style={{
                                                  color: 'white',
                                                  top: '0px',
                                                  position: 'relative',
                                                  marginRight: '0px'
                                                }}
                                              ></i>
                                            </button>
                                          </div>
                                        )}
                                      </>
                                        </div>
                                        <ul className="nav user-profile navbar-nav ml-auto text-right">   
                                            <ul className="nav-item user-avatar-items dropdown">
                                                <a className="nav-link dropdown-toggle" data-toggle="dropdown" href="/aaa">
                                                {uid === '3' ? 
                                                    <div className="username-and-type">
                                                        <span className="loggedinuser">
                                                            <i className="icon-userimage"></i> <span className="username">Robin Aylor</span>
                                                        </span>
                                                        <span className="usertype">{urole}</span>
                                                    </div>:
                                                    <div className="username-and-type">
                                                        <span className="loggedinuser">
                                                            <i className="icon-userimage"></i> <span className="username">User</span>
                                                        </span>
                                                        { urole === 'SUPERADMIN' ? 
                                                            <span className="usertype">SUPERADMIN</span>:<span className="usertype"></span>
                                                        } 
                                                        { urole === 'ATHLETIC_MANAGER' ? 
                                                            <span className="usertype">ATHLETIC DIRECTOR</span>:<span className="usertype"></span>
                                                        }  
                                                        { urole === 'HO_SCHOOL' ? 
                                                            <span className="usertype">HOS SCHOOL</span>:<span className="usertype"></span>
                                                        } 
                                                        { urole === 'ASSOCIATION_USER' ? 
                                                            <span className="usertype">ASSOCIATION USER</span>:<span className="usertype"></span>
                                                        } 
                                                        { urole === 'OFFICIALS_USER' ? 
                                                            <span className="usertype">{coach}</span>:<span className="usertype"></span>
                                                        } 
                                                    </div>
                                                    }
                                                    {uid === '3' ? 
                                                    <div className="profile-pic">
                                                        <img src={Userimg} width="" height="" alt="" />
                                                    </div>:<div className="profile-pic">
                                                    <img src={Userimg2} width="" height="" alt="" />
                                                    </div>
                                                    }
                                        
                                                </a>
                                                
                                                

                                                <div className="dropdown-menu dropdown-menu-right">
            
                                                    {/* <button className="dropdown-item" href="#">My Profile</button> */}
                                                    <button className="dropdown-item" onClick={ resetPassword }>Reset Password</button>
                                                    <button onClick={Logout} className="dropdown-item" href="#">Logout</button>											
                                                </div>
                                            </ul>
                                        </ul>
                                    </div>):null
                            }
                            
                        </div> 
                    </div>
                </div>
			</header>   
        </aside>        
    </div>
</div>
    </Fragment>)
};

export default HeadNavbar;